import * as Module from "@adeccoux/tag-ds";
import { faRemove } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ReportGmailerrorredRoundedIcon from "@mui/icons-material/ReportGmailerrorredRounded";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import TagFacesIcon from "@mui/icons-material/TagFaces";
import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

function PopupXpert({ toggle, message, buttonText }) {
    let location = useLocation();
    const testPhrases = location.state.user.siteConfig.phrases;

    return (
        <div
            className="modal fade ng-isolate-scope in"
            style={{ zIndex: 1050, display: "block" }}
        >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-body scrollable ng-binding ng-scope">
                        {testPhrases[message]}
                    </div>
                    <div className="modal-footer ng-scope">
                        <button
                            aria-label={testPhrases[buttonText]}
                            className="ng-binding ng-scope btn btn-primary"
                            onClick={toggle}
                        >
                            {testPhrases[buttonText]}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

function PopupBreatherFM({ toggle, totalStage, completedStage }) {
    let location = useLocation();
    const testPhrases = location.state.user.siteConfig.phrases;
    let completedList = [];
    let remainingList = [];
    let activeList = [];
    let counter = 1;
    let thankYouFlag = false;
    const stepperRef = useRef();
    if (completedStage == totalStage) {
        thankYouFlag = true;
    }
    for (let i = 0; i < completedStage; i++) {
        completedList.push(counter++);
    }
    if (!thankYouFlag) {
        activeList.push(counter++);
    }
    for (let i = 0; i < totalStage - completedStage - 1; i++) {
        remainingList.push(counter++);
    }
    const getNameSuffix = (value, message) => {
        let str = value + "";
        if (value == 1) {
            str += "st";
        } else if (value == 2) {
            str += "nd";
        } else if (value == 3) {
            str += "rd";
        } else {
            str += "th";
        }
        return str + " round";
    };
    const successItems = completedList.map((value) => (
        <Module.Step name={getNameSuffix(value)} status="success" />
    ));
    const activeItems = activeList.map((value) => (
        <Module.Step name={getNameSuffix(value)} status="active" />
    ));
    const remainingItems = remainingList.map((value) => (
        <Module.Step name={getNameSuffix(value)} status="default" />
    ));
    const handleResize = () => {
        if (
            stepperRef.current?.children[0].children[1].className ==
            "stepper-mobile-progress"
        ) {
            stepperRef.current.children[0].children[1].children[0].style.width = `${(completedStage / totalStage) * 100
                }%`;
            if (completedStage == totalStage) {
                stepperRef.current.children[0].children[0].children[1].innerText = `${completedStage}/${totalStage}`;
            }
        }
    };

    useEffect(() => {
        handleResize();
    }, [stepperRef.current, completedStage]);

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className="counter-main">
            <div className="tag-ds docs breather-container">
                {thankYouFlag && (
                    <div>
                        <i
                            onClick={() => toggle()}
                            style={{
                                float: "right",
                                marginRight: "0px",
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faRemove}
                                style={{ color: "grey", fontSize: "17px" }}
                            />
                        </i>
                    </div>
                )}
                <div className="tag-ds" ref={stepperRef}>
                    <Module.Stepper>
                        {successItems}
                        {activeItems}
                        {remainingItems}
                    </Module.Stepper>
                </div>
                <div className="centerDivStd">
                    <TagFacesIcon
                        sx={{ fontSize: 60 }}
                        style={{ marginTop: "30%" }}
                    />
                </div>
                {!thankYouFlag && (
                    <label
                        className="tag-ds"
                        style={{
                            textAlign: "center",
                            fontSize: "24px",
                            marginTop: "1%",
                            marginBottom: "1.5%",
                        }}
                    >
                        {testPhrases["20023550"]}
                    </label>
                )}
                {!thankYouFlag && (
                    <large
                        className=""
                        style={{
                            textAlign: "center",
                            fontSize: "16px",
                            color: "#5C6573",
                        }}
                    >
                        {testPhrases["20023557"]}
                    </large>
                )}
                {!thankYouFlag && (
                    <large
                        className=""
                        style={{
                            textAlign: "center",
                            fontSize: "16px",
                            color: "#5C6573",
                            marginLeft: "5%",
                            marginRight: "5%",
                        }}
                    >
                        {testPhrases["20023558"]}
                    </large>
                )}
                {thankYouFlag && (
                    <large
                        className=""
                        style={{
                            textAlign: "center",
                            fontSize: "16px",
                            color: "#5C6573",
                            marginLeft: "5%",
                            marginRight: "5%",
                        }}
                    >
                        {testPhrases["20022496"]}
                    </large>
                )}
                {!thankYouFlag && (
                    <button
                        aria-label={testPhrases["10928"]}
                        className="button-secondary_medium centerDivStd"
                        style={{ width: "15%", marginTop: "4%" }}
                        onClick={() => toggle()}
                    >
                        {testPhrases["10928"]}
                    </button>
                )}
            </div>
        </div>
    );
}

function MeterPositiveNotif({ header, body, notifType, deActivate }) {
    let location = useLocation();
    const testPhrases = location.state.user.siteConfig.phrases;

    const renderSwitch = (param) => {
        switch (param) {
            case 1:
                return <TagFacesIcon fontSize="large" />;

            case 2:
                return <SentimentVeryDissatisfiedIcon fontSize="large" />;
            case 3:
                return <ReportGmailerrorredRoundedIcon fontSize="large" />;
            case 4:
                return <CheckCircleOutlineRoundedIcon fontSize="large" />;
        }
    };

    console.log("Insid ");
    return (
        <div className="tag-ds counter-main" onClick={deActivate}>
            <Module.Notification
                className="notification-changes docs"
                data-testid="notification"
                iconclose
                onClose={deActivate}
                icon={renderSwitch(notifType)}
                show
                success={notifType == 1}
                error={notifType == 2}
                warning={notifType == 3}
                info={notifType == 4}
            >
                <Module.NotificationHeader>{header}</Module.NotificationHeader>
                <Module.NotificationBody>{body}</Module.NotificationBody>
                <Module.NotificationFooter className="text_uppercase ">
                    <a role="link" className="link_small" onClick={deActivate}>
                        {testPhrases["10976"]}
                    </a>
                </Module.NotificationFooter>
            </Module.Notification>
        </div>
    );
}
export default {
    PopupXpert,
    PopupBreatherFM,
    MeterPositiveNotif,
};
